<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Relatório de <strong>Alunos com Documentos</strong></h4>

    <form @submit.prevent="generateReport">
      <div class="row">
        <div class="form-group col-md-6">

          <div class="mb-3">
            <SearchableSelect
              v-model="student_id"
              :options="students"
              item-text="name"
              item-value="id"
              label="Aluno (Opcional)"
              placeholder="-- Todos os alunos --"
              :loading="loadingStudents"
              @search="searchStudents"
            />
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="start_date" class="form-label">Data Inicial (Opcional)</label>
              <input type="date" v-model="start_date" class="form-control form-control-sm" id="start_date">
            </div>
            <div class="col-md-6 mb-3">
              <label for="end_date" class="form-label">Data Final (Opcional)</label>
              <input type="date" v-model="end_date" class="form-control form-control-sm" id="end_date">
            </div>
          </div>

          <div v-if="!loading" class="form-group text-center my-2">
            <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
              Gerar Relatório
            </button>
            <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
              Limpar
            </button>
          </div>

          <LoadingPage v-else />

        </div>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import { handleBlobError } from "@/helpers";
import studentSearchMixin from "@/mixins/studentSearchMixin";

export default {
  name: "StudentsWithDocumentsReport",
  mixins: [studentSearchMixin],
  components: {
    LoadingPage,
    SearchableSelect,
  },
  data() {
    return {
      student_id: "",
      start_date: "",
      end_date: "",
      loading: false,
    };
  },
  methods: {
    async generateReport() {
      this.loading = true;

      const params = {};
      if (this.student_id) params.student_id = this.student_id;
      if (this.start_date) params.start_date = this.start_date;
      if (this.end_date) params.end_date = this.end_date;

      try {
        const response = await api.get("/exports/students-with-documents", {
          params,
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `relatorio_alunos_com_documentos_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        Toast.fire("Sucesso", "Relatório gerado com sucesso!", "success");
      } catch (error) {
        handleBlobError(error, (message) => {
          Toast.fire("Erro", message, "error");
        });
      } finally {
        this.loading = false;
      }
    },
    clearForm() {
      this.student_id = "";
      this.start_date = "";
      this.end_date = "";
    },
  },
  mounted() {
    this.searchStudents();
  },
};
</script>

<style scoped>
</style>
